import React, { createContext, useContext, useEffect, useReducer, useMemo } from 'react';
import { gEnums } from '../../enums/globalEnums';
import { headerHandlers, headerInitialState, headerReducer } from '../reducers/HeaderReducer';
import { ParentContext } from './ParentContext';

export const HeaderContext = createContext();

const HeaderProvider = (props) => {

  const { states } = useContext(ParentContext) ?? {};
  const { appUser_state, paps_state, page_state, currentSettings_state } = states ?? {};

  const { appUser } = appUser_state ?? {};
  const { nonLandingView, view, viewKey } = paps_state ?? {};
  const { aps_page, aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});;
  const { pageDataCaption } = page_state ?? {};
  const { topMenu: topMenu_app, projectOptions } = aps_global ?? {};
  const { allowFavorites, favoriteCollections } = aps_appUserSettings ?? {};
  const { allowSiteSearch } = projectOptions ?? {};

  const {
    mainFixedCaption,
    mainFixedSubCaption,
    captionCharacterMax = 36,
  } = topMenu_app ?? {};

  const { menu: menu_page } = aps_page ?? {};
  const { captionType, caption: caption_page } = menu_page ?? {};

  const _showFavorite = viewKey && allowFavorites && favoriteCollections?.includes(view);

  const _appCaptions = useMemo(() => {
    const captions = { main: mainFixedCaption ? mainFixedCaption : 'Name' };

    if (view !== 'landing') {
      captions.main = _.startCase(nonLandingView);
    }

    if (view === 'landing' && mainFixedCaption) {
      captions.main = mainFixedCaption;
      captions.sub = mainFixedSubCaption;
    } else if (view === 'appProfile') {
      captions.main = appUser ? `Profile - ${appUser.displayName}` : 'Profile';
    } else {
      captions.main = pageDataCaption || (menu_page?.caption || 'caption');
    }

    if (captionType === gEnums.captionTypes.fixed) {
      captions.main = caption_page;
    }


    return captions;
  }, [view, nonLandingView, appUser, pageDataCaption, menu_page, captionType, caption_page, mainFixedCaption]);

  let _captionCharacterMax = captionCharacterMax;
  if (allowSiteSearch) _captionCharacterMax -= 3;
  if (_showFavorite) _captionCharacterMax -= 3;

  // Ensure the caption fits within the max length
  const trimmedCaption = _appCaptions?.main?.length > _captionCharacterMax
    ? `${_appCaptions.main.substring(0, _captionCharacterMax)}...`
    : _appCaptions?.main || '';

  const init_state = { appCaptions: { main: trimmedCaption }, allowSiteSearch, menuTitleMax: _captionCharacterMax };

  const [header_state, header_dispatch] = useReducer(headerReducer, headerInitialState(init_state));

  const header_handlers = useMemo(
    () => headerHandlers(header_dispatch),
    [header_dispatch]
  );

  useEffect(() => {
    header_handlers.handleUpdateHeader({ main: trimmedCaption });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trimmedCaption]);

  return (
    <HeaderContext.Provider value={{ ...props, header_handlers, header_state }}>
      {props.children}
    </HeaderContext.Provider>
  );
};

export default HeaderProvider; 